//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./autoresearch.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// enum AutoResearchMetric
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class AutoResearchMetric extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum AutoResearchRunStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class AutoResearchRunStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct AutoResearchRunConfig
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `AutoResearchRunConfig.Mutable`. */
export class AutoResearchRunConfig extends $._FrozenBase {}

function initAutoResearchRunConfig(target, initializer) {
  target.metric = AutoResearchMetric.create(initializer.metric ?? AutoResearchMetric.UNKNOWN);
  target.focusArea = initializer.focusArea ?? "";
  target.numHypotheses = initializer.numHypotheses ?? 0;
  target.topK = initializer.topK ?? 0;
  target.dataWindow = initializer.dataWindow ?? 0;
}

// -----------------------------------------------------------------------------
// enum HypothesisStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class HypothesisStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum EvidenceQuality
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class EvidenceQuality extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum EvidenceVerifiability
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class EvidenceVerifiability extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct HypothesisEvidence
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `HypothesisEvidence.Mutable`. */
export class HypothesisEvidence extends $._FrozenBase {}

function initHypothesisEvidence(target, initializer) {
  target.sourceType = initializer.sourceType ?? "";
  target.description = initializer.description ?? "";
  target.dealName = initializer.dealName ?? "";
  target.meetingId = initializer.meetingId ?? "";
  target.quote = initializer.quote ?? "";
  target.speaker = initializer.speaker ?? "";
  target.metricName = initializer.metricName ?? "";
  target.metricValue = initializer.metricValue ?? 0;
  target.evidenceQuality = EvidenceQuality.create(initializer.evidenceQuality ?? EvidenceQuality.UNKNOWN);
  target.meetingOffsetSeconds = initializer.meetingOffsetSeconds ?? 0;
  target.crmAccountId = initializer.crmAccountId ?? BigInt(0);
  target.crmAccountName = initializer.crmAccountName ?? "";
  target.crmAccountDomain = initializer.crmAccountDomain ?? "";
  target.supportsClaimBecause = initializer.supportsClaimBecause ?? "";
  target.verifiability = EvidenceVerifiability.create(initializer.verifiability ?? EvidenceVerifiability.UNKNOWN);
  target.sourceId = initializer.sourceId ?? "";
  target.toolCall = initializer.toolCall ?? "";
  target.claimComponentId = initializer.claimComponentId ?? "";
  target.mechanism = initializer.mechanism ?? "";
}

// -----------------------------------------------------------------------------
// enum ClaimComponentKind
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class ClaimComponentKind extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct ClaimComponent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ClaimComponent.Mutable`. */
export class ClaimComponent extends $._FrozenBase {}

function initClaimComponent(target, initializer) {
  target.id = initializer.id ?? "";
  target.kind = ClaimComponentKind.create(initializer.kind ?? ClaimComponentKind.UNKNOWN);
  target.description = initializer.description ?? "";
  target.counterDescription = initializer.counterDescription ?? "";
}

// -----------------------------------------------------------------------------
// struct HypothesisDataSignals
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `HypothesisDataSignals.Mutable`. */
export class HypothesisDataSignals extends $._FrozenBase {}

function initHypothesisDataSignals(target, initializer) {
  target.prevalenceCount = initializer.prevalenceCount ?? 0;
  target.totalMeetingsInWindow = initializer.totalMeetingsInWindow ?? 0;
  target.dealsWithPatternWon = initializer.dealsWithPatternWon ?? 0;
  target.dealsWithPatternLost = initializer.dealsWithPatternLost ?? 0;
  target.dealsWithoutPatternWon = initializer.dealsWithoutPatternWon ?? 0;
  target.dealsWithoutPatternLost = initializer.dealsWithoutPatternLost ?? 0;
  target.coachingGapScore = initializer.coachingGapScore ?? 0;
  target.coOccurrenceStrength = initializer.coOccurrenceStrength ?? 0;
  target.taxonomyRank = initializer.taxonomyRank ?? 0;
  target.dealHealthDelta = initializer.dealHealthDelta ?? 0;
  target.methodologyComplianceRate = initializer.methodologyComplianceRate ?? 0;
  target.answerCoverageGapRate = initializer.answerCoverageGapRate ?? 0;
  target.pValue = initializer.pValue ?? 0;
  target.oddsRatio = initializer.oddsRatio ?? 0;
  target.sampleSizePattern = initializer.sampleSizePattern ?? 0;
  target.sampleSizeControl = initializer.sampleSizeControl ?? 0;
  target.trendDirection = initializer.trendDirection ?? "";
  target.trendMagnitude = initializer.trendMagnitude ?? 0;
  target.transcriptHitRate = initializer.transcriptHitRate ?? 0;
  target.taxonomyCreated = initializer.taxonomyCreated ?? false;
}

// -----------------------------------------------------------------------------
// struct HypothesisCohort
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `HypothesisCohort.Mutable`. */
export class HypothesisCohort extends $._FrozenBase {}

function initHypothesisCohort(target, initializer) {
  target.repEmails = $._toFrozenArray(
    initializer.repEmails || []);
    target.dealStages = $._toFrozenArray(
      initializer.dealStages || []);
      target.segments = $._toFrozenArray(
        initializer.segments || []);
        target.dealSizeBand = initializer.dealSizeBand ?? "";
        target.competitors = $._toFrozenArray(
          initializer.competitors || []);
}

// -----------------------------------------------------------------------------
// struct HypothesisResultEntry
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `HypothesisResultEntry.Mutable`. */
export class HypothesisResultEntry extends $._FrozenBase {}

function initHypothesisResultEntry(target, initializer) {
  target.claim = initializer.claim ?? "";
  target.rationale = initializer.rationale ?? "";
  target.stage = initializer.stage ?? "";
  target.category = initializer.category ?? "";
  target.evidenceFor = $._toFrozenArray(
    initializer.evidenceFor || [],
    HypothesisEvidence.create,
  );
  target.evidenceAgainst = $._toFrozenArray(
    initializer.evidenceAgainst || [],
    HypothesisEvidence.create,
  );
  target.dataSignals = HypothesisDataSignals.create(initializer.dataSignals ?? HypothesisDataSignals.DEFAULT);
  target.confidence = initializer.confidence ?? 0;
  target.confidenceBreakdown = initializer.confidenceBreakdown ?? "";
  target.investigationNotes = initializer.investigationNotes ?? "";
  target.status = HypothesisStatus.create(initializer.status ?? HypothesisStatus.UNKNOWN);
  target.improvementText = initializer.improvementText ?? "";
  target.improvementScenario = initializer.improvementScenario ?? "";
  target.improvementStage = initializer.improvementStage ?? "";
  target.improvementRationale = initializer.improvementRationale ?? "";
  target.cohort = initializer.cohort ? HypothesisCohort.create(initializer.cohort) : null;
  target.cohortNDeals = initializer.cohortNDeals ?? 0;
  target.cohortNCalls = initializer.cohortNCalls ?? 0;
  target.claimComponents = $._toFrozenArray(
    initializer.claimComponents || [],
    ClaimComponent.create,
  );
}

// -----------------------------------------------------------------------------
// struct HypothesisRun
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `HypothesisRun.Mutable`. */
export class HypothesisRun extends $._FrozenBase {}

function initHypothesisRun(target, initializer) {
  target.id = initializer.id ?? "";
  target.accountId = initializer.accountId ?? BigInt(0);
  target.userId = initializer.userId ?? "";
  target.config = AutoResearchRunConfig.create(initializer.config ?? AutoResearchRunConfig.DEFAULT);
  target.status = AutoResearchRunStatus.create(initializer.status ?? AutoResearchRunStatus.UNKNOWN);
  target.summary = initializer.summary ?? "";
  target.hypotheses = $._toFrozenArray(
    initializer.hypotheses || [],
    HypothesisResultEntry.create,
  );
  target.totalGenerated = initializer.totalGenerated ?? 0;
  target.totalExplored = initializer.totalExplored ?? 0;
  target.totalWellSupported = initializer.totalWellSupported ?? 0;
  target.totalContradicted = initializer.totalContradicted ?? 0;
  target.improvementsGenerated = initializer.improvementsGenerated ?? 0;
  target.startedAt = initializer.startedAt ?? $.Timestamp.UNIX_EPOCH;
  target.completedAt = initializer.completedAt ?? null;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "autoresearch.skir",
  [
    {
      kind: "enum",
      ctor: AutoResearchMetric,
      name: "AutoResearchMetric",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "WIN_RATE",
          number: 1,
        },
        {
          name: "STALE_RATE",
          number: 5,
        },
      ],
      removedNumbers: [
        2,
        3,
        4,
      ],
    },
    {
      kind: "enum",
      ctor: AutoResearchRunStatus,
      name: "AutoResearchRunStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "RUNNING",
          number: 1,
        },
        {
          name: "COMPLETED",
          number: 2,
        },
        {
          name: "FAILED",
          number: 3,
        },
        {
          name: "PARTIAL",
          number: 4,
        },
        {
          name: "CANCELLED",
          number: 5,
        },
      ],
    },
    {
      kind: "struct",
      ctor: AutoResearchRunConfig,
      initFn: initAutoResearchRunConfig,
      name: "AutoResearchRunConfig",
      fields: [
        {
          name: "metric",
          property: "metric",
          number: 0,
          type: {
            kind: "record",
            ctor: AutoResearchMetric,
          },
        },
        {
          name: "focus_area",
          property: "focusArea",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "num_hypotheses",
          property: "numHypotheses",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "top_k",
          property: "topK",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "data_window",
          property: "dataWindow",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: HypothesisStatus,
      name: "HypothesisStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "NEW",
          number: 1,
        },
        {
          name: "EXPLORED",
          number: 2,
        },
        {
          name: "WELL_SUPPORTED",
          number: 3,
        },
        {
          name: "CONTRADICTED",
          number: 4,
        },
        {
          name: "INSUFFICIENT_EVIDENCE",
          number: 5,
        },
      ],
    },
    {
      kind: "enum",
      ctor: EvidenceQuality,
      name: "EvidenceQuality",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "ANECDOTAL",
          number: 1,
        },
        {
          name: "PATTERN",
          number: 2,
        },
        {
          name: "STATISTICAL",
          number: 3,
        },
        {
          name: "SYSTEMATIC",
          number: 4,
        },
      ],
    },
    {
      kind: "enum",
      ctor: EvidenceVerifiability,
      name: "EvidenceVerifiability",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "ASSERTED",
          number: 1,
        },
        {
          name: "VERIFIED_QUOTE",
          number: 2,
        },
        {
          name: "VERIFIED_METRIC",
          number: 3,
        },
        {
          name: "VERIFIED_EMAIL",
          number: 4,
        },
      ],
    },
    {
      kind: "struct",
      ctor: HypothesisEvidence,
      initFn: initHypothesisEvidence,
      name: "HypothesisEvidence",
      fields: [
        {
          name: "source_type",
          property: "sourceType",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "deal_name",
          property: "dealName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_id",
          property: "meetingId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "quote",
          property: "quote",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "speaker",
          property: "speaker",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "metric_name",
          property: "metricName",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "metric_value",
          property: "metricValue",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "evidence_quality",
          property: "evidenceQuality",
          number: 8,
          type: {
            kind: "record",
            ctor: EvidenceQuality,
          },
        },
        {
          name: "meeting_offset_seconds",
          property: "meetingOffsetSeconds",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "crm_account_id",
          property: "crmAccountId",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "crm_account_name",
          property: "crmAccountName",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_account_domain",
          property: "crmAccountDomain",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "supports_claim_because",
          property: "supportsClaimBecause",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "verifiability",
          property: "verifiability",
          number: 14,
          type: {
            kind: "record",
            ctor: EvidenceVerifiability,
          },
        },
        {
          name: "source_id",
          property: "sourceId",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "tool_call",
          property: "toolCall",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "claim_component_id",
          property: "claimComponentId",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "mechanism",
          property: "mechanism",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: ClaimComponentKind,
      name: "ClaimComponentKind",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "SUBJECT",
          number: 1,
        },
        {
          name: "BEHAVIOR",
          number: 2,
        },
        {
          name: "CONDITION",
          number: 3,
        },
        {
          name: "OUTCOME",
          number: 4,
        },
        {
          name: "MECHANISM",
          number: 5,
        },
      ],
    },
    {
      kind: "struct",
      ctor: ClaimComponent,
      initFn: initClaimComponent,
      name: "ClaimComponent",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "kind",
          property: "kind",
          number: 1,
          type: {
            kind: "record",
            ctor: ClaimComponentKind,
          },
        },
        {
          name: "description",
          property: "description",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "counter_description",
          property: "counterDescription",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: HypothesisDataSignals,
      initFn: initHypothesisDataSignals,
      name: "HypothesisDataSignals",
      fields: [
        {
          name: "prevalence_count",
          property: "prevalenceCount",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_meetings_in_window",
          property: "totalMeetingsInWindow",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "deals_with_pattern_won",
          property: "dealsWithPatternWon",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "deals_with_pattern_lost",
          property: "dealsWithPatternLost",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "deals_without_pattern_won",
          property: "dealsWithoutPatternWon",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "deals_without_pattern_lost",
          property: "dealsWithoutPatternLost",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "coaching_gap_score",
          property: "coachingGapScore",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "co_occurrence_strength",
          property: "coOccurrenceStrength",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "taxonomy_rank",
          property: "taxonomyRank",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "deal_health_delta",
          property: "dealHealthDelta",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "methodology_compliance_rate",
          property: "methodologyComplianceRate",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "answer_coverage_gap_rate",
          property: "answerCoverageGapRate",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "p_value",
          property: "pValue",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "odds_ratio",
          property: "oddsRatio",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "sample_size_pattern",
          property: "sampleSizePattern",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "sample_size_control",
          property: "sampleSizeControl",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "trend_direction",
          property: "trendDirection",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "trend_magnitude",
          property: "trendMagnitude",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "transcript_hit_rate",
          property: "transcriptHitRate",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "taxonomy_created",
          property: "taxonomyCreated",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: HypothesisCohort,
      initFn: initHypothesisCohort,
      name: "HypothesisCohort",
      fields: [
        {
          name: "rep_emails",
          property: "repEmails",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableRepEmails",
        },
        {
          name: "deal_stages",
          property: "dealStages",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableDealStages",
        },
        {
          name: "segments",
          property: "segments",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableSegments",
        },
        {
          name: "deal_size_band",
          property: "dealSizeBand",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "competitors",
          property: "competitors",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableCompetitors",
        },
      ],
    },
    {
      kind: "struct",
      ctor: HypothesisResultEntry,
      initFn: initHypothesisResultEntry,
      name: "HypothesisResultEntry",
      fields: [
        {
          name: "claim",
          property: "claim",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rationale",
          property: "rationale",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage",
          property: "stage",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "category",
          property: "category",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "evidence_for",
          property: "evidenceFor",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: HypothesisEvidence,
            },
          },
          mutableGetter: "mutableEvidenceFor",
        },
        {
          name: "evidence_against",
          property: "evidenceAgainst",
          number: 5,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: HypothesisEvidence,
            },
          },
          mutableGetter: "mutableEvidenceAgainst",
        },
        {
          name: "data_signals",
          property: "dataSignals",
          number: 6,
          type: {
            kind: "record",
            ctor: HypothesisDataSignals,
          },
          mutableGetter: "mutableDataSignals",
        },
        {
          name: "confidence",
          property: "confidence",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "confidence_breakdown",
          property: "confidenceBreakdown",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "investigation_notes",
          property: "investigationNotes",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "status",
          property: "status",
          number: 10,
          type: {
            kind: "record",
            ctor: HypothesisStatus,
          },
        },
        {
          name: "improvement_text",
          property: "improvementText",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "improvement_scenario",
          property: "improvementScenario",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "improvement_stage",
          property: "improvementStage",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "improvement_rationale",
          property: "improvementRationale",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "cohort",
          property: "cohort",
          number: 15,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: HypothesisCohort,
            },
          },
        },
        {
          name: "cohort_n_deals",
          property: "cohortNDeals",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "cohort_n_calls",
          property: "cohortNCalls",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "claim_components",
          property: "claimComponents",
          number: 18,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ClaimComponent,
            },
          },
          mutableGetter: "mutableClaimComponents",
        },
      ],
    },
    {
      kind: "struct",
      ctor: HypothesisRun,
      initFn: initHypothesisRun,
      name: "HypothesisRun",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "user_id",
          property: "userId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "config",
          property: "config",
          number: 3,
          type: {
            kind: "record",
            ctor: AutoResearchRunConfig,
          },
          mutableGetter: "mutableConfig",
        },
        {
          name: "status",
          property: "status",
          number: 4,
          type: {
            kind: "record",
            ctor: AutoResearchRunStatus,
          },
        },
        {
          name: "summary",
          property: "summary",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "hypotheses",
          property: "hypotheses",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: HypothesisResultEntry,
            },
          },
          mutableGetter: "mutableHypotheses",
        },
        {
          name: "total_generated",
          property: "totalGenerated",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_explored",
          property: "totalExplored",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_well_supported",
          property: "totalWellSupported",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_contradicted",
          property: "totalContradicted",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "improvements_generated",
          property: "improvementsGenerated",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "started_at",
          property: "startedAt",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "completed_at",
          property: "completedAt",
          number: 13,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
    },
  ]
);
